import { useEffect } from 'react';

import { B2BTouchpointLayout } from './featureB/B2BTouchpointLayout';
import { useB2BTouchpoint } from './hooks/useB2BTouchpoint';
import { layoutType, type B2BTouchpointHandlerProps } from './interfaces';

export const B2BTouchpoint = ({
  classNames,
  layout,
  isTopBanner,
}: B2BTouchpointHandlerProps) => {
  const {
    ffB2bTouchpointListingPage,
    onDisplay,
    onClick,
    pageName,
    pageType,
    hasBeenDisplayed,
    elementRef,
    isFirstPage,
  } = useB2BTouchpoint(isTopBanner);

  useEffect(() => {
    if (pageName && pageType && hasBeenDisplayed) {
      onDisplay();
    }
  }, [pageName, pageType, hasBeenDisplayed, onDisplay]);

  if (ffB2bTouchpointListingPage && isFirstPage) {
    return (
      <B2BTouchpointLayout
        classNames={classNames}
        onClick={onClick}
        isLayoutInspirational={layout === layoutType.INSPIRATIONAL}
        ref={elementRef}
      />
    );
  }
  return null;
};
